"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _defaultTranslations = require("./defaultTranslations");

var _ProfileImage = _interopRequireDefault(require("./ProfileImage"));

var _ProfileHelp = _interopRequireDefault(require("./ProfileHelp"));

var _ProfileForm = _interopRequireDefault(require("./ProfileForm"));

var _ProfileGdpr = _interopRequireDefault(require("./ProfileGdpr"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Profile = function Profile(_ref) {
  var translations = _ref.translations,
      onError = _ref.onError,
      onLogoutSuccess = _ref.onLogoutSuccess,
      onProfileSaveSuccess = _ref.onProfileSaveSuccess,
      onVerifyMobileClicked = _ref.onVerifyMobileClicked,
      onChangePinClicked = _ref.onChangePinClicked,
      onChangePasswordClicked = _ref.onChangePasswordClicked,
      customButtonText = _ref.customButtonText,
      customButtonPath = _ref.customButtonPath,
      isOpenWalletButtonSpecial = _ref.isOpenWalletButtonSpecial,
      hideGamblingReferences = _ref.hideGamblingReferences,
      hideLow6Button = _ref.hideLow6Button,
      hideOpenWalletButton = _ref.hideOpenWalletButton,
      hideVerifyButton = _ref.hideVerifyButton,
      hideChangePin = _ref.hideChangePin,
      hideChangePassword = _ref.hideChangePassword,
      hideLogoutButton = _ref.hideLogoutButton,
      hideAddressTitle = _ref.hideAddressTitle,
      hideGdprCheckboxes = _ref.hideGdprCheckboxes,
      hidePushNotifcationCheckbox = _ref.hidePushNotifcationCheckbox,
      hideSmsCheckbox = _ref.hideSmsCheckbox,
      hideEmailCheckbox = _ref.hideEmailCheckbox,
      hideCheckAllCheckbox = _ref.hideCheckAllCheckbox,
      hideEmailField = _ref.hideEmailField,
      showEmailReadonly = _ref.showEmailReadonly,
      hideCity = _ref.hideCity,
      hidePostcode = _ref.hidePostcode,
      hideLine1 = _ref.hideLine1,
      isMinimalAddress = _ref.isMinimalAddress,
      isFiver = _ref.isFiver,
      isScore6 = _ref.isScore6,
      isNonUkUser = _ref.isNonUkUser,
      ctaUrl = _ref.ctaUrl,
      ctaIconUrl = _ref.ctaIconUrl,
      ctaText = _ref.ctaText,
      disableProfileImage = _ref.disableProfileImage,
      tenantDetails = _ref.tenantDetails,
      privacySlug = _ref.privacySlug,
      useAssestsCdn = _ref.useAssestsCdn,
      onPageButtonClicked = _ref.onPageButtonClicked,
      forcedCountryCode = _ref.forcedCountryCode;
  (0, _react.useEffect)(function () {
    window.xtremepush("tag", "profile", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []);

  if (!translations) {
    translations = (0, _defaultTranslations.defaultTranslations)(isNonUkUser);
  }

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      profile = _useState2[0],
      setProfile = _useState2[1];

  var getProfile = (0, _react.useCallback)(function () {
    _axios.default.get("/me?include=address").then(function (_ref2) {
      var data = _ref2.data;
      setProfile(data === null || data === void 0 ? void 0 : data.data);
    }).catch(function (_ref3) {
      var response = _ref3.response;
      onError(response);
    });
  }, [onError]);
  (0, _react.useEffect)(function () {
    getProfile();
  }, [getProfile]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileImage.default, {
      customButtonPath: customButtonPath,
      customButtonText: customButtonText,
      disableProfileImage: disableProfileImage,
      hideGamblingReferences: hideGamblingReferences,
      hideLow6Button: hideLow6Button,
      isOpenWalletButtonSpecial: isOpenWalletButtonSpecial,
      hideOpenWalletButton: hideOpenWalletButton,
      translations: translations,
      username: profile === null || profile === void 0 ? void 0 : profile.username,
      image: profile === null || profile === void 0 ? void 0 : profile.image,
      onError: onError,
      getProfile: getProfile,
      ctaUrl: ctaUrl,
      ctaIconUrl: ctaIconUrl,
      ctaText: ctaText
    }), !profile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.SkeletonTable, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileForm.default, {
        translations: translations,
        setProfile: setProfile,
        onVerifyMobileClicked: onVerifyMobileClicked,
        onProfileSaveSuccess: onProfileSaveSuccess,
        onChangePinClicked: onChangePinClicked,
        onChangePasswordClicked: onChangePasswordClicked,
        onLogoutSuccess: onLogoutSuccess,
        onError: onError,
        profile: profile,
        hideChangePassword: hideChangePassword,
        hideAddressTitle: hideAddressTitle,
        hideVerifyButton: hideVerifyButton,
        hideChangePin: hideChangePin,
        hideLogoutButton: hideLogoutButton,
        hideEmailField: hideEmailField,
        showEmailReadonly: showEmailReadonly,
        hideCity: hideCity,
        hidePostcode: hidePostcode,
        hideLine1: hideLine1,
        isFiver: isFiver,
        isScore6: isScore6,
        isNonUkUser: isNonUkUser,
        isMinimalAddress: isMinimalAddress,
        forcedCountryCode: forcedCountryCode
      }), !hideGdprCheckboxes && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileGdpr.default, {
        onError: onError,
        onProfileSaveSuccess: onProfileSaveSuccess,
        translations: translations,
        profile: profile,
        hidePushNotifcationCheckbox: hidePushNotifcationCheckbox,
        hideSmsCheckbox: hideSmsCheckbox,
        hideEmailCheckbox: hideEmailCheckbox,
        hideCheckAllCheckbox: hideCheckAllCheckbox,
        tenantDetails: tenantDetails,
        privacySlug: privacySlug,
        useAssestsCdn: useAssestsCdn,
        onPageButtonClicked: onPageButtonClicked
      }), !hideGamblingReferences && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileHelp.default, {
        translations: translations
      })]
    })]
  });
};

var _default = Profile;
exports.default = _default;